export interface DmTimelinePosition {
  dmXid: string;
  latestItemKey: string | null;
}

/**
 * Decide how an open DM should follow its timeline.
 *
 * Opening a conversation jumps straight to its latest item. New items that
 * arrive in the conversation are followed smoothly so the recipient sees
 * them without refreshing or manually scrolling.
 */
export function dmAutoScrollBehavior(
  previous: DmTimelinePosition | null,
  current: DmTimelinePosition,
): "auto" | "smooth" | null {
  if (current.latestItemKey === null) return null;
  if (previous === null || previous.dmXid !== current.dmXid) return "auto";
  if (previous.latestItemKey !== current.latestItemKey) return "smooth";
  return null;
}

export function dmComposerPlaceholder(
  ready: boolean,
  focused: boolean,
  recipientLabel: string,
): string {
  if (!ready) return "Securing this conversation…";
  if (focused) return "";
  return `Message ${recipientLabel}`;
}
